import { computed, Ref, ref, ComputedRef, watch } from 'vue';
import { PortalType } from '@studyportals/domain-client';

import getters from '@/study-search/store/getters';
import { Mobile } from '@/study-search/infrastructure/Mobile';

export default class Faq {
	public openIndexes: Ref<number[]> = ref([]);
	private readonly isMobile = Mobile.instance.isMobile;

	constructor() {
		watch(() => this.faqs.value, () => {
			this.openIndexes.value = [];
		});
	}

	public isPortalTypeMasters = computed(() => getters.getPortalType() === PortalType.MASTER);

	public faqs = computed(() => {
		const content = getters.getFaqStaticContent();
		return content?.faqs || [];
	});

	public isFaqsEmpty = computed(() => this.faqs.value.length === 0);

	public handleToggle(id: number): void {
		if (this.isMobile.value) {
			this.openIndexes.value = this.openIndexes.value[0] === id ? [] : [id];
			return;
		}

		if (this.openIndexes.value.includes(id)) {
			this.openIndexes.value = this.openIndexes.value.filter(i => i !== id)
		} else {
			this.openIndexes.value.push(id)
		}
	}

	public isOpened(index: number): ComputedRef<boolean> {
		return computed(() => this.openIndexes.value.includes(index));
	}
}
